import * as React from 'react';
import PropTypes from 'prop-types';

function Back(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  const { color = '#fff', width = '24', height = '24' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <g
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_634_152)"
      >
        <path d="M12 21a9 9 0 100-18 9 9 0 000 18zM8 12l4 4M8 12h8M12 8l-4 4" />
      </g>
      <defs>
        <clipPath id="clip0_634_152">
          <path fill="#fff" d="M0 0H24V24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
Back.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Back;
